(() => {
  'use strict';
  const TABLE = [[4,14.9],[4.5,15.3],[5,15.7],[5.5,16.1],[6,16.5],[6.5,16.9],[7,17.3],[7.5,17.7],[8,18.1],[8.5,18.5],[9,18.9],[9.5,19.4],[10,19.8],[10.5,20.2],[11,20.6],[11.5,21],[12,21.4],[12.5,21.8],[13,22.2]];
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const SCALE_MIN=0.5,SCALE_MAX=20;
  const validScaleNumber = n => Number.isFinite(n) && n >= SCALE_MIN && n <= SCALE_MAX;
  const validDiameter = n => Number.isFinite(n) && n >= 13 && n <= 24;
  // These are consistency limits, not a claim of physical measurement accuracy.
  const scaleAgreement = (x,y) => Number.isFinite(x) && Number.isFinite(y) && x > 0 && y > 0 && Math.abs(x-y) / ((x+y)/2) <= 0.010000001;
  const repeatAgreement = (a,b) => validDiameter(a) && validDiameter(b) && Math.abs(a-b) <= 0.150001;
  function sizing(diameter) {
    if (!Number.isFinite(diameter) || diameter < TABLE[0][1] || diameter > TABLE[TABLE.length-1][1]) return null;
    const nearest = TABLE.reduce((a,b) => Math.abs(a[1]-diameter) <= Math.abs(b[1]-diameter) ? a : b);
    let between = null;
    for (let i=0; i<TABLE.length-1; i++) {
      if (Math.abs(diameter - (TABLE[i][1]+TABLE[i+1][1])/2) <= 0.075001) between = [TABLE[i][0],TABLE[i+1][0]];
    }
    return { us:nearest[0], eu:Math.round(diameter*Math.PI), diameter, circumference:diameter*Math.PI, between };
  }
  function optionSystem(option) {
    if (!option || typeof option.name !== 'string' || !Array.isArray(option.values)) return null;
    const name=option.name.toLowerCase();
    if (!option.values.length || option.values.some(value=>!Number.isFinite(optionNumber(value)))) return null;
    if (Object.prototype.hasOwnProperty.call(option,'ringSizeSystem')) return ['us','eu','diameter'].includes(option.ringSizeSystem)?option.ringSizeSystem:null;
    if (!option.values.some(v=>Number.isFinite(optionNumber(v)))) return null;
    if (/diameter|diamètre|диаметр/.test(name)) return 'diameter';
    if (!/size|talla|taille|размер/.test(name)) return null;
    if (/eu\b|europe|circumference/.test(name)) return 'eu';
    if (/us\b|u\.s\.|usa|canada/.test(name)) return 'us';
    const numbers = option.values.map(v => optionNumber(v));
    if (numbers.length && numbers.every(v=>Number.isFinite(v)&&v>=4&&v<=13)) return 'us';
    if (numbers.length && numbers.every(v=>Number.isFinite(v)&&v>=44&&v<=70)) return 'eu';
    return null;
  }
  function optionNumber(value) {
    const text = String(value && typeof value === 'object' ? value.name : value).trim().replace(/^(US|EU)\s*/i,'').replace(',', '.');
    return /^\d+(?:\.\d+)?$/.test(text) ? Number(text) : NaN;
  }
  function availableMatch(config, result, selected=[]) {
    if (!result || result.between || !Array.isArray(config?.options)) return null;
    const option=config.options?.find(o=>optionSystem(o));
    if (!option) return null;
    const system=optionSystem(option), target=system==='us'?result.us:system==='eu'?result.eu:result.diameter;
    const value=option.values.map(v=>v && typeof v==='object'?String(v.name):String(v)).find(v=> {
      const n=optionNumber(v);
      return Number.isFinite(n) && Math.abs(n-target) < (system==='diameter'?0.06:0.001);
    });
    if (!value) return null;
    const index=Number(option.position)-1;
    if (!Number.isInteger(index) || index < 0) return null;
    const selectedValue=i=>{
      if(selected[i])return selected[i];
      const other=config.options.find(o=>Number(o.position)===i+1);
      return other?.values.length===1?String(typeof other.values[0]==='object'?other.values[0].name:other.values[0]):'';
    };
    const available=config.variants?.some(v=>v.available && Array.isArray(v.options) && v.options[index]===value && v.options.every((o,i)=>i===index || selectedValue(i)===o));
    return available?{ option, value, system }:null;
  }
  function requestedMatch(config, result, values) {
    if (!result || result.between || config.options?.some(o=>optionSystem(o))) return null;
    const value='US '+result.us;
    return values.includes(value) ? {value, system:'us', requested:true} : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports={TABLE,sizing,scaleAgreement,repeatAgreement,optionSystem,availableMatch,requestedMatch,optionNumber};
  if (typeof document === 'undefined' || typeof customElements === 'undefined') return;
  if (!customElements.get('jb-ring-sizer')) customElements.define('jb-ring-sizer',class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort=new AbortController();
      try {this.config=JSON.parse(this.querySelector('[data-rs-config]').textContent);} catch (_) {this.abort.abort();this.abort=null;return;}
      this.strings=this.config.strings;
      this.method='card'; this.y=3.78; this.x=3.78; this.diameter=17.3; this.phase='intro'; this.first=null; this.result=null;
      const signal=this.abort.signal;
      this.motionPreference=window.matchMedia?.('(prefers-reduced-motion: reduce)');
      this.motionPreference?.addEventListener?.('change',()=>this.ensureLesson(),{signal});
      this.addEventListener('click',e=>{const b=e.target.closest?.('[data-rs-action]'); if(b&&this.contains(b)){e.preventDefault();this.action(b.dataset.rsAction);}}, {signal});
      this.addEventListener('jb:ring-sizer-start',()=>{this.reset();this.show('intro');},{signal});
      this.addEventListener('jb:ring-sizer-reset',()=>this.reset(),{signal});
      const onInput=e=>{
        if(e.target.matches('[data-rs="calibration"]') && this.phase==='calibrate') {this.y=this.adjustedInput(e.target,SCALE_MIN,SCALE_MAX,0.005);this.clearMeasurements();}
        if(e.target.matches('[data-rs="verification"]') && this.phase==='verify') {this.x=this.adjustedInput(e.target,SCALE_MIN,SCALE_MAX,0.005);this.get('verify-confirm').checked=false;this.clearMeasurements();}
        if(e.target.matches('[data-rs="diameter"]') && (this.phase==='measure'||this.phase==='repeat')) {this.diameter=this.adjustedInput(e.target,13,24,0.05);this.result=null;this.notify('');}
        this.renderGuides();
        this.ensureLesson();
      };
      this.addEventListener('input',onInput,{signal});
      this.addEventListener('change',e=>{if(e.target.matches('input[type="range"]'))onInput(e);else this.updateActions();},{signal});
      this.onResize=()=>{
        if(!this.getClientRects().length){this.stopLessons();return;}
        const expected=this.signature||this.calibrationSignature;
        if(expected && expected!==this.viewportSignature()) this.invalidate();
        this.renderGuides();
        this.ensureLesson();
      };
      window.addEventListener('resize',this.onResize,{signal,passive:true});
      window.visualViewport?.addEventListener('resize',this.onResize,{signal,passive:true});
      const onOrientation=()=>{if(this.signature||this.calibrationSignature)this.invalidate();};
      window.screen?.orientation?.addEventListener('change',onOrientation,{signal});
      window.addEventListener('orientationchange',onOrientation,{signal,passive:true});
      window.addEventListener('pageshow',this.onResize,{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stopLessons();else this.onResize();},{signal});
      this.closest('dialog')?.addEventListener('close',()=>this.reset(),{signal});
      if(typeof ResizeObserver==='function'){
        this.observer=new ResizeObserver(()=>{
          if(!this.getClientRects().length){this.stopLessons();return;}
          if(this.signature && !this.geometryValid()) this.invalidate();
          this.renderGuides();
          this.ensureLesson();
        });
        this.observer.observe(this);
      }
      // Moving a desktop window between screens can change its physical scale
      // without a resize event. Monitor only an active measurement session.
      this.screenTimer=window.setInterval(()=>{
        if(!document.hidden && (this.signature||this.calibrationSignature||this.activeLesson()))this.onResize();
      },600);
      this.reset();
    }
    disconnectedCallback() {this.stopLessons();this.abort?.abort();this.abort=null;this.observer?.disconnect();window.clearInterval(this.screenTimer);}
    get(key) {return this.querySelector('[data-rs="'+key+'"]');}
    msg(key) {return this.strings?.[key]||key;}
    adjustedInput(input,min,max,step) {const n=Number(input.value);return Number.isFinite(n)?clamp(Math.round(n/step)*step,min,max):min;}
    viewportSignature() {
      const screen=window.screen||{};
      // Height is deliberately excluded: mobile address-bar collapse does not
      // change the physical length of a CSS pixel.
      return [window.devicePixelRatio||1,window.visualViewport?.scale||1,window.innerWidth,screen.width,screen.height,screen.orientation?.angle||window.orientation||0].join(':');
    }
    elementScale(element) {
      if(!element?.getClientRects().length)return null;
      const style=getComputedStyle(element),rect=element.getBoundingClientRect();
      const outer=(axis,sides)=>parseFloat(style[axis])+(style.boxSizing==='border-box'?0:sides.reduce((sum,key)=>sum+(parseFloat(style[key])||0),0));
      const width=outer('width',['paddingLeft','paddingRight','borderLeftWidth','borderRightWidth']);
      const height=outer('height',['paddingTop','paddingBottom','borderTopWidth','borderBottomWidth']);
      return width>0&&height>0&&rect.width>0&&rect.height>0?{x:rect.width/width,y:rect.height/height}:null;
    }
    geometryValid() {
      const scale=this.elementScale(this);
      if(!this.componentScale||!scale)return false;
      if(Math.abs(scale.x-this.componentScale.x)>0.001||Math.abs(scale.y-this.componentScale.y)>0.001)return false;
      const ringScale=this.elementScale(this.get('ring'));
      // The ring is hidden on the result panel; component scaling is still
      // checked there. Each measurement checks both rendered ring axes.
      if(!ringScale)return this.phase==='result';
      return this.referenceScale && Math.abs(ringScale.x-this.referenceScale.x)<=0.001 && Math.abs(ringScale.y-this.referenceScale.y)<=0.001;
    }
    clearMeasurements() {this.first=null;this.result=null;}
    clearCalibration() {
      this.signature=null;this.calibrationSignature=null;this.calibrationScale=null;this.referenceScale=null;this.componentScale=null;this.clearMeasurements();
      this.get('verify-confirm').checked=false;
    }
    notify(key) {this.get('notice').textContent=key?this.msg(key):'';}
    activeLesson() {
      const name=this.phase==='calibrate'?this.method:this.phase==='verify'?(this.method==='card'?'card-turn':'ruler-check'):this.phase==='measure'?'ring':this.phase==='repeat'?'repeat':null;
      return name?this.querySelector('[data-rs-lesson="'+name+'"]'):null;
    }
    lessonVisible(lesson) {return this.isConnected&&!document.hidden&&!this.hidden&&lesson&&!lesson.hidden&&this.getClientRects().length>0&&lesson.getClientRects().length>0;}
    stopLessons() {
      if(this.lessonFrame!==undefined){window.cancelAnimationFrame?.(this.lessonFrame);this.lessonFrame=undefined;}
      this.querySelectorAll('[data-rs-lesson]').forEach(lesson=>{lesson.classList.remove('is-playing');lesson.classList.add('is-settled');});
    }
    ensureLesson() {
      const active=this.activeLesson();
      if(!this.lessonVisible(active)||this.motionPreference?.matches){this.stopLessons();return;}
      if(active.classList.contains('is-playing')||this.lessonFrame!==undefined)return;
      this.playLesson();
    }
    syncLessons(play=true) {
      this.stopLessons();
      const active=this.activeLesson();
      this.querySelectorAll('[data-rs-lesson]').forEach(lesson=>lesson.hidden=lesson!==active);
      if(play)this.ensureLesson();
    }
    playLesson() {
      this.stopLessons();
      const active=this.activeLesson();
      if(!this.lessonVisible(active)||this.motionPreference?.matches||typeof window.requestAnimationFrame!=='function')return;
      const phase=this.phase;
      this.lessonFrame=window.requestAnimationFrame(()=>{
        this.lessonFrame=window.requestAnimationFrame(()=>{
          this.lessonFrame=undefined;
          if(this.lessonVisible(active)&&!this.motionPreference?.matches&&this.phase===phase&&this.activeLesson()===active){active.classList.remove('is-settled');active.classList.add('is-playing');}
        });
      });
    }
    reset() {this.clearCalibration();this.diameter=17.3;this.get('fit').checked=false;this.show('intro',false);this.notify('');}
    invalidate() {
      const active=document.activeElement;
      const panel=active&&this.contains(active)?active.closest?.('[data-rs-panel]'):null;
      const focus=Boolean(panel&&this.contains(panel)&&!panel.hidden&&panel.dataset.rsPanel!=='calibrate'&&!document.hidden&&!this.hidden&&this.getClientRects().length);
      this.clearCalibration();this.show('calibrate',focus);this.notify('recalibrate');
    }
    show(phase,focus=true) {
      this.phase=phase;
      if(phase==='calibrate')this.querySelector('.jb-rs-cal-stage').style.height=Math.max(window.innerWidth<=600?360:280,this.reference()*this.y+36)+'px';
      const panelPhase=phase==='repeat'?'measure':phase;
      this.querySelectorAll('[data-rs-panel]').forEach(p=>p.hidden=p.dataset.rsPanel!==panelPhase);
      this.querySelectorAll('[data-rs-reading]').forEach(p=>p.hidden=p.dataset.rsReading!==phase);
      const current={intro:0,help:0,calibrate:1,verify:1,measure:2,repeat:2,result:3}[phase];
      this.querySelectorAll('[data-rs-step]').forEach(el=>{el.classList.toggle('is-current',Number(el.dataset.rsStep)===current);if(Number(el.dataset.rsStep)===current)el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
      this.renderGuides();this.updateActions();
      const substep=this.get('substep'),substepKey={calibrate:'substep_screen_first',verify:'substep_screen_second',measure:'substep_ring_first',repeat:'substep_ring_second',result:'substep_result'}[phase];
      if(substep){substep.hidden=!substepKey;substep.textContent=substepKey?this.msg(substepKey):'';}
      this.syncLessons();
      if(focus) {const h=this.querySelector('[data-rs-reading="'+phase+'"] h3')||this.querySelector('[data-rs-panel="'+panelPhase+'"] h3');h?.focus({preventScroll:true});h?.scrollIntoView({block:'nearest',behavior:'auto'});}
    }
    updateActions() {
      const start=this.querySelector('[data-rs-action="start"]');if(start)start.disabled=!this.get('fit').checked;
      this.querySelector('[data-rs-action="verified"]').disabled=!this.get('verify-confirm').checked || !this.verifyFits || !this.calibrationSignature;
    }
    reference() {return this.method==='card'?53.98:50;}
    verificationReference() {return this.method==='card'?53.98:30;}
    renderGuides() {
      if(!this.abort)return;
      for(const [key,value] of [['calibration',this.y],['verification',this.x],['diameter',this.diameter]]) {const input=this.get(key);if(Math.abs(Number(input.value)-value)>0.000001)input.value=String(value);}
      this.get('vertical-guide').style.height=(this.reference()*this.y)+'px';
      this.get('horizontal-guide').style.width=(this.verificationReference()*this.x)+'px';
      this.get('vertical-label').textContent=this.method==='card'?this.msg('card_short'):this.msg('ruler_50');
      this.get('horizontal-label').textContent=this.method==='card'?this.msg('card_short'):this.msg('ruler_30');
      this.get('calibration-instruction').textContent=this.method==='card'?this.msg('card_instruction'):this.msg('ruler_instruction');
      this.get('verification-instruction').textContent=this.method==='card'?this.msg('rotate_card'):this.msg('ruler_verify');
      this.querySelectorAll('[data-rs-method]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.rsMethod===this.method)));
      const v=this.get('verify-stage');
      const style=getComputedStyle(v);
      const contentWidth=v.clientWidth-(parseFloat(style.paddingLeft)||0)-(parseFloat(style.paddingRight)||0);
      this.verifyFits=this.phase!=='verify' || (validScaleNumber(this.x) && contentWidth>0 && this.verificationReference()*this.x <= contentWidth+0.001);
      this.get('verify-overflow').hidden=this.verifyFits;
      const ring=this.get('ring');
      ring.style.width=(this.diameter*this.x)+'px';ring.style.height=(this.diameter*this.y)+'px';
      this.get('diameter-output').textContent=this.diameter.toFixed(2)+' '+this.msg('mm');
      this.get('diameter').setAttribute('aria-valuetext',this.diameter.toFixed(2)+' '+this.msg('mm'));
      this.updateActions();
    }
    action(action) {
      const allowed={ready:['intro'],start:['intro'],help:['intro'],card:['calibrate'],ruler:['calibrate','verify'],'cal-minus':['calibrate'],'cal-plus':['calibrate'],'verify-minus':['verify'],'verify-plus':['verify'],'diameter-minus':['measure','repeat'],'diameter-plus':['measure','repeat'],calibrated:['calibrate'],verified:['verify'],'save-first':['measure'],'save-second':['repeat'],again:['repeat','result'],'recheck-screen':['measure','repeat','result'],apply:['result']};
      if(allowed[action]&&!allowed[action].includes(this.phase))return;
      this.notify('');
      if(action==='ready'){this.get('fit').checked=true;this.show('calibrate');return;}
      if(action==='start') {if(this.get('fit').checked)this.show('calibrate');return;}
      if(action==='help'){this.show('help');return;}
      if(action==='restart'){this.reset();return;}
      if(action==='recheck-screen'){this.clearCalibration();this.show('calibrate');return;}
      if(action==='back'){
        const phases={calibrate:'intro',verify:'calibrate',measure:'verify',help:'intro'};
        if(this.phase==='measure'){this.signature=null;this.referenceScale=null;this.componentScale=null;this.clearMeasurements();this.get('verify-confirm').checked=false;}
        else this.clearCalibration();
        this.show(phases[this.phase]||'intro');return;
      }
      if(action==='card'||action==='ruler'){this.clearCalibration();this.method=action;if(this.phase!=='calibrate')this.show('calibrate');else {this.renderGuides();this.syncLessons();}return;}
      if(action==='cal-minus'||action==='cal-plus'){this.y=clamp(Math.round((this.y+(action==='cal-plus'?0.005:-0.005))*1000)/1000,SCALE_MIN,SCALE_MAX);this.renderGuides();return;}
      if(action==='verify-minus'||action==='verify-plus'){this.x=clamp(Math.round((this.x+(action==='verify-plus'?0.005:-0.005))*1000)/1000,SCALE_MIN,SCALE_MAX);this.get('verify-confirm').checked=false;this.renderGuides();return;}
      if(action==='diameter-minus'||action==='diameter-plus'){this.diameter=clamp(Math.round((this.diameter+(action==='diameter-plus'?0.05:-0.05))*100)/100,13,24);this.renderGuides();return;}
      if(action==='calibrated'){
        if(!validScaleNumber(this.y))return;
        const scale=this.elementScale(this.get('vertical-guide'));
        if(!scale)return;
        this.calibrationSignature=this.viewportSignature();this.calibrationScale=scale;this.clearMeasurements();
        this.x=this.y;this.get('verify-confirm').checked=false;this.show('verify');return;
      }
      if(action==='verified') {
        if(!this.get('verify-confirm').checked||!this.verifyFits)return;
        if(!this.calibrationSignature||this.calibrationSignature!==this.viewportSignature()){this.invalidate();return;}
        const scale=this.elementScale(this.get('horizontal-guide'));
        if(!scale||!this.calibrationScale||!validScaleNumber(this.x)||!validScaleNumber(this.y))return;
        if(!scaleAgreement(this.x*scale.x,this.y*this.calibrationScale.y)){this.notify('scale_mismatch');return;}
        this.referenceScale={x:scale.x,y:this.calibrationScale.y};
        this.signature=this.viewportSignature();this.show('measure');this.componentScale=this.elementScale(this);
        if(!this.geometryValid())this.invalidate();return;
      }
      if(action==='save-first') {
        if(!this.validScale()||!validDiameter(this.diameter))return;
        this.first=this.diameter;this.diameter=Number((this.first+(this.first>23.5?-0.4:0.4)).toFixed(2));this.show('repeat');return;
      }
      if(action==='save-second') {
        if(!this.validScale())return;
        if(!repeatAgreement(this.first,this.diameter)){this.notify('repeat_mismatch');return;}
        this.result=sizing((this.first+this.diameter)/2);this.renderResult();this.show('result');return;
      }
      if(action==='again'){if(!this.validScale())return;const diameter=this.result?.diameter??this.first??this.diameter;this.clearMeasurements();this.diameter=validDiameter(diameter)?Number((Math.round(diameter/0.05)*0.05).toFixed(2)):17.3;this.show('measure');return;}
      if(action==='apply')this.applySize();
    }
    validScale() {if(!this.signature||this.signature!==this.viewportSignature()||!this.geometryValid()){this.invalidate();return false;}return true;}
    productScope() {return this.closest('.product-information--inner, .product-information')||this.closest('.shopify-section')||this.parentElement;}
    productControls() {
      const productId=String(this.config.productId||''),formId=this.config.productFormId;
      const controls=Array.from(this.productScope().querySelectorAll('select[name],input[name]')).filter(el=>{
        const parent=el.closest('[data-product-id]');
        if(productId&&parent?.dataset.productId&&parent.dataset.productId!==productId)return false;
        if(formId&&el.form&&el.form.getAttribute('id')!==formId)return false;
        return true;
      });
      // Controls associated with the exact product form take precedence over
      // unassociated theme radio inputs in the same product section.
      return controls.sort((a,b)=>Number(b.form?.getAttribute('id')===formId)-Number(a.form?.getAttribute('id')===formId));
    }
    selectedOptions() {
      const controls=this.productControls();
      return (this.config.options||[]).map(o=> {
        const named=controls.filter(el=>el.name==='options['+o.name+']'||el.name===o.name);
        const exact=named.filter(el=>this.config.productFormId&&el.form?.getAttribute('id')===this.config.productFormId);
        const eligible=exact.length?exact:named;
        const control=eligible.find(el=>el.tagName==='INPUT'&&el.checked)||eligible.find(el=>el.tagName==='SELECT');
        return control?.value||'';
      });
    }
    requestedControl() {
      if(this.config.options?.some(o=>optionSystem(o)))return null;
      const productId=String(this.config.productId||'');
      const choices=Array.from(this.productScope().querySelectorAll('jb-ring-size-choice[data-product-id]')).filter(el=>!productId||el.dataset.productId===productId);
      if(choices.length!==1)return null;
      const control=choices[0].querySelector('select[data-jb-ring-size]');
      if(!control||control.disabled||this.config.productFormId&&control.form?.getAttribute('id')!==this.config.productFormId)return null;
      return control;
    }
    selectionMatch(result) {
      const numbered=availableMatch(this.config,result,this.selectedOptions());
      if(numbered)return numbered;
      const control=this.requestedControl();
      if(!control)return null;
      const match=requestedMatch(this.config,result,Array.from(control.options).filter(o=>!o.disabled).map(o=>o.value));
      return match?{...match,control}:null;
    }
    renderResult() {
      const r=this.result;
      const details=this.get('measurement-details');if(details)details.open=false;
      this.get('result-values').hidden=!r;this.get('outside').hidden=Boolean(r);
      this.get('between').hidden=!r?.between;
      this.get('use-size').hidden=true;this.get('availability').hidden=true;
      if(!r)return;
      this.get('us-result').textContent=r.between?r.between.join(' – '):String(r.us);
      this.get('eu-result').textContent=String(r.eu);
      this.get('diameter-result').textContent=r.diameter.toFixed(1)+' '+this.msg('mm');
      this.get('circumference-result').textContent=r.circumference.toFixed(1)+' '+this.msg('mm');
      const match=this.selectionMatch(r);
      if(match){
        this.get('use-size').hidden=false;
        this.get('use-size').textContent=match.requested?this.msg('use_requested_size')+' '+r.us:this.msg('use_size')+' '+match.value+' ('+this.msg(match.system)+')';
        if(match.requested){this.get('availability').hidden=false;this.get('availability').textContent=this.msg('request_size_note');}
      }
      else if(this.config.options?.length){this.get('availability').hidden=false;this.get('availability').textContent=this.msg(r.between?'between_advice':'confirm_availability');}
    }
    applySize() {
      if(!this.validScale())return;
      const match=this.selectionMatch(this.result);
      if(!match){this.notify('confirm_availability');return;}
      const control=match.requested?match.control:this.productControls().find(el=>(el.name==='options['+match.option.name+']'||el.name===match.option.name)&&(el.tagName==='SELECT'||el.value===match.value));
      if(!control){this.notify('confirm_availability');return;}
      const option=control.tagName==='SELECT'?Array.from(control.options).find(o=>o.value===match.value):control;
      if(!option||option.disabled){this.notify('confirm_availability');return;}
      if(control.tagName==='SELECT')control.value=match.value;else control.checked=true;
      if(control.disabled){this.notify('confirm_availability');return;}
      control.dispatchEvent(new Event('input',{bubbles:true}));
      control.dispatchEvent(new Event('change',{bubbles:true}));
      const dialog=this.closest('dialog');
      if(dialog?.closest('jb-ring-sizer-dialog'))dialog.closest('jb-ring-sizer-dialog').close();
      else if(dialog?.closest('jb-size-guide'))dialog.closest('jb-size-guide').close();
      control.focus({preventScroll:true});
    }
  });
  if (!customElements.get('jb-ring-sizer-dialog')) customElements.define('jb-ring-sizer-dialog',class extends HTMLElement {
    connectedCallback() {
      if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.dialog=this.querySelector('dialog');
      if(!this.dialog)return;
      document.addEventListener('click',e=>{
        const opener=e.target.closest?.('.cus_sz_chrt_tbl__open,[data-rs-open]');
        if(!opener||opener.closest('.shopify-section')!==this.closest('.shopify-section'))return;
        e.preventDefault();this.opener=opener;this.open();
      },{signal});
      this.querySelector('[data-rs-close]')?.addEventListener('click',()=>this.close(),{signal});
      this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.close();},{signal});
      this.dialog.addEventListener('click',e=>{if(e.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();},{signal});
      this.dialog.addEventListener('close',()=>this.release(),{signal});
      // Native dialog is available in supported evergreen browsers. This
      // keyboard fallback also keeps older embedded webviews usable.
      document.addEventListener('keydown',e=>{
        if(!this.dialog.hasAttribute('open')||typeof this.dialog.showModal==='function')return;
        if(e.key==='Escape'){e.preventDefault();this.close();return;}
        if(e.key!=='Tab')return;
        const focusable=Array.from(this.dialog.querySelectorAll('button,a[href],input,select,textarea,[tabindex]')).filter(el=>!el.disabled&&el.tabIndex>=0&&el.getClientRects().length);
        if(!focusable.length){e.preventDefault();return;}
        const first=focusable[0],last=focusable[focusable.length-1];
        if(e.shiftKey&&(document.activeElement===first||!this.dialog.contains(document.activeElement))){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&(document.activeElement===last||!this.dialog.contains(document.activeElement))){e.preventDefault();first.focus();}
      },{signal});
    }
    open() {
      if(!this.dialog||this.dialog.hasAttribute('open'))return;this.oldOverflow=document.body.style.overflow;
      if(typeof this.dialog.showModal==='function')this.dialog.showModal();
      else {this.dialog.setAttribute('open','');this.dialog.setAttribute('role','dialog');this.dialog.setAttribute('aria-modal','true');}
      document.body.style.overflow='hidden';
      this.opener?.setAttribute('aria-expanded','true');this.opener?.setAttribute('aria-controls',this.dialog.id);
      this.dialog.querySelector('[data-rs-close]')?.focus({preventScroll:true});document.dispatchEvent(new CustomEvent('panel:open',{detail:{panel:this.dialog}}));
    }
    close() {
      if(!this.dialog?.hasAttribute('open'))return;
      if(typeof this.dialog.close==='function')this.dialog.close();
      else {this.dialog.removeAttribute('open');this.dialog.dispatchEvent(new Event('close'));}
    }
    release() {if(this.oldOverflow!==undefined){document.body.style.overflow=this.oldOverflow;this.oldOverflow=undefined;this.opener?.setAttribute('aria-expanded','false');if(this.opener?.isConnected)this.opener.focus({preventScroll:true});document.dispatchEvent(new CustomEvent('panel:closed'));}}
    disconnectedCallback() {this.close();this.release();this.abort?.abort();this.abort=null;}
  });
})();
